// extracted by mini-css-extract-plugin
export default {"offer":"offer_offer__Wk4pW","offer_title":"offer_offer_title__o9uL3","offer_item":"offer_offer_item__ffXEp","link":"offer_link__4fSlN"};